<table *ngIf="guestsData" class="guests-grid">
    <tr>
        <th *ngIf="!isBadgeExtension"><span appEllipsisTooltip>Photo</span></th>
        <th><span appEllipsisTooltip>First name</span></th>
        <th><span appEllipsisTooltip>Last name</span></th>
        <th><span appEllipsisTooltip>Mobile number</span></th>
        <th><span appEllipsisTooltip>Email</span></th>
        <th><span appEllipsisTooltip>Company</span></th>
        <!-- <th><span appEllipsisTooltip>Entity/FSS</span></th> -->
        <th><span appEllipsisTooltip>Visit start</span></th>
        <th><span appEllipsisTooltip>Visit end</span></th>
        <th>
            <i class="icon-notification-bell"></i>
        </th>
        <th></th>
    </tr>

    <tbody>
    <ng-container *ngFor="let guest of guestsData; let index = index">
        <tr *ngIf="index !== guestIndex" [class.has-errors]="guest.errors?.length">
            <td *ngIf="!isBadgeExtension" class="photo-cell">
                <img
                    [src]="guest.photoInfo ? (guest.photoInfo['file'] ? guest.photoInfo['file']?.url : defaultImageUrl) : defaultImageUrl"
                    alt="">
                <i
                    *ngIf="hasMissingPhoto(guest)"
                    class="icon-exclamation_mark_circled missing-photo-icon"
                    tabindex="0"
                    role="img"
                    aria-label="Profile picture missing"
                    [tooltip]="'Please upload the picture.'"
                ></i>
            </td>
            <td><span appEllipsisTooltip>{{ guest.firstName }}</span></td>
            <td><span appEllipsisTooltip>{{ guest.lastName }}</span></td>
            <td><span appEllipsisTooltip>{{ guest.localCellNumber }}</span></td>
            <td><span appEllipsisTooltip>{{ guest.email }}</span></td>
            <td><span appEllipsisTooltip>{{ guest.companyName }}</span></td>
            <!-- <td><span appEllipsisTooltip>{{ guest.entityOrFssName }}</span></td> -->
            <td>{{ guest.visitStartDate | date: 'M/d/yy' }}</td>
            <td>{{ guest.visitEndDate | date: 'M/d/yy' }}</td>
            <td>
                <i
                    *ngIf="guest.notification; else iconPlaceholder"
                    class="icon-comment"
                    [tooltip]="guest.notification"
                ></i>
                <i
                    class="icon-edit"
                    [class.disabled]="guestToEdit || !showAddGuestButton"
                    [tooltip]="'Edit visitor'"
                    (click)="openEditGuest(guest, index)"
                ></i>
                <i
                    class="icon-delete"
                    [class.disabled]="guestToEdit || !showAddGuestButton"
                    [tooltip]="'Delete visitor'"
                    (click)="deleteGuest(guest)"
                ></i>
            </td>
            <td>
                <i
                    *ngIf="guest.errors?.length"
                    class="icon-exclamation_mark_circled"
                    style="color: red; cursor: pointer;"
                    [tooltip]="guest.errors.join('\n')"
                ></i>
            </td>
        </tr>
        <tr *ngIf="isEdit && index === guestIndex" class="edit-row">
            <td [attr.colspan]="isBadgeExtension ? 9 : 10">
                <employee-edit-none-deloitte
                    (guestEdited)="editGuest($event)"
                    (cancel)="cancel($event)"
                    [guestData]="guestToEdit"
                    [isBadgeExtension]="isBadgeExtension"
                ></employee-edit-none-deloitte>
            </td>
        </tr>
    </ng-container>

    </tbody>
</table>

<button
    class="button text with-icon add-button"
    *ngIf="showAddGuestButton"
    [class.disabled]="guestToEdit"
    (click)="addNewGuest()">
    <i class="icon-plus"></i>
    Add new visitor
</button>


<ng-template #iconPlaceholder>
    <i class="icon-placeholder"></i>
</ng-template>
